export default __webpack_public_path__ + "static/feature3-22e72cbb1474676edea75ead9c4cfddc.webp";